import type { RefObject } from "react";
import { Icon } from "./style";
import * as Styled from "./style";
import { URL } from "~/components/blocks/layout/global-navi/const/url";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";

type RightIconsProps = {
  onDisplayUserMenu?: () => void;
  onDisplaySearch?: () => void;
  userMenuButtonRef?: RefObject<HTMLButtonElement>;
  searchButtonRef?: RefObject<HTMLButtonElement>;
};

export const RightIcons = ({
  onDisplaySearch,
  onDisplayUserMenu,
  userMenuButtonRef,
  searchButtonRef,
}: RightIconsProps) => {
  const { handleClickByDevice } = useHandleClickByDevice();

  return (
    <Styled.DivIconWrapper>
      <Styled.ButtonIconWrapper
        type="button"
        ref={searchButtonRef}
        isSearch
        {...handleClickByDevice<HTMLButtonElement>(() => {
          if (onDisplaySearch) onDisplaySearch();
        })}
      >
        <Icon name="search" size="XXL" color="GRAY900" />
      </Styled.ButtonIconWrapper>

      <Styled.AnchorIconWrapper href={URL.coupon}>
        <Icon name="coupon" size="XXL" color="GRAY900" />
      </Styled.AnchorIconWrapper>

      <Styled.ButtonIconWrapper
        ref={userMenuButtonRef}
        {...handleClickByDevice<HTMLButtonElement>(() => {
          if (onDisplayUserMenu) onDisplayUserMenu();
        })}
      >
        <Icon name="account" size="XXL" color="GRAY900" />
      </Styled.ButtonIconWrapper>
    </Styled.DivIconWrapper>
  );
};
